const { vin65 } = window;

export const init = () => { // eslint-disable-line import/prefer-default-export
  setLoadingGraphic();
  handleFormSubmissions();
  customReloadBillingElements();
};

const setLoadingGraphic = () => {
  vin65.modal.loadingGraphic = "<img src='/assets/images/icon-loading.svg'>";
};

const handleFormSubmissions = () => {
  const v65FormResponse = vin65.form.formResponse;
  vin65.form.formResponse = (response, formDiv) => {
    v65FormResponse(response, formDiv);
    const event = new CustomEvent('v65-formSubmission', {
      detail: {
        id: formDiv,
        response,
      },
    });
    window.dispatchEvent(event);
  };
};

const customReloadBillingElements = () => {
  const v65ReloadBillingElements = vin65.checkout.reloadBillingElements;
  vin65.checkout.reloadBillingElements = () => {
    v65ReloadBillingElements();
    const event = new CustomEvent('v65-reloadBillingElements');
    window.dispatchEvent(event);
  };
};



// WEBPACK FOOTER //
// ./src/assets/js/v65Customizations.js